/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_New_ProjectInputs */



/**
* | output |
* | --- |
* | "Open the New Project window" |
*
* @param {Shortcut_Keys_Desc_New_ProjectInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_new_project = /** @type {((inputs?: Shortcut_Keys_Desc_New_ProjectInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_New_ProjectInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ouvrir la fenetre Nouveau projet")
	if (locale === "de") return /** @type {LocalizedString} */ ("Öffnen Sie das Fenster „Neues Projekt“.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Apri la finestra Nuovo progetto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Откройте окно «Новый проект».")
	if (locale === "es") return /** @type {LocalizedString} */ ("Abrir la ventana Nuevo proyecto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("打开“新建项目”窗口")
	if (locale === "ja") return /** @type {LocalizedString} */ ("新しいプロジェクトウィンドウを開く")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नया प्रोजेक्ट विंडो खोलें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Abra a janela Novo Projeto.")
	return /** @type {LocalizedString} */ ("Open the New Project window")
});